import { AfterContentInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ClientAction, FileDataModel } from '../../../models/file-upload/file-data';
import { ResponseStatus } from '../../../shared/components/sem-dynamic/sem-dynamic.component';
import { SemControlComponent } from '../sem-control/sem-control.component';
import { SemFileExplorerDialogComponent } from '../dialogs/sem-file-explorer-dialog/sem-file-explorer-dialog.component';

@Component({
  selector: 'sem-messenger',
  templateUrl: './sem-messenger.component.html',
  styleUrls: ['./sem-messenger.component.css']
})
export class SemMessengerComponent extends SemControlComponent implements OnInit, AfterContentInit, OnDestroy {

  @Input() inputPlaceholder: string = "";
  @Input() fileUploadEnabled: boolean = true;
  @Input() afterSaveApiEndpoint: string|null = null;
  @Output() saveFormReq = new EventEmitter<string>();
  @Input() fileSectionType: any = 17;

  inputMessageValue: string = "";
  event: any;
  availableExtensions: any[] = ["pdf", "png", "jpg", "jpeg"];
  alreadyExists: boolean = false;
  file: any = null;
  message: string = "";

  private fileUpload: ElementRef;
  @ViewChild('fileUpload', { static: false }) set content(content: ElementRef) {
    if (content) { // initially setter gets called with undefined
      this.fileUpload = content;
    }
  }

  ngAfterContentInit(): void {
  }
  ngOnDestroy(): void {
  }


  openFileExporer(file: any){        
    this.dialog.open(SemFileExplorerDialogComponent, {
      data: {
        files: [file],
        availableExtensions: this.availableExtensions,
        type: 3,                
      },
      height: "calc(100% - 100px)",
      width: "calc(100% - 100px)",
      autoFocus: false
    }).afterClosed().subscribe((t: any) => {     

    });
  }

openFileExplorerExisting(filename: string): void {
  const medias = this.model["Medias"] ?? [];
  const media = medias.find((m: any) => m.Name === filename);

  if (!media) {
    return; // early exit if no matching file
  }

  this.dialog.open(SemFileExplorerDialogComponent, {
    data: {
      files: [{ FileID: media.Id, Name: filename }],
      availableExtensions: this.availableExtensions,
      type: 3,
      model: { Id: this.dfms.getValue(this.model, "Id") }
    },
    height: "calc(100% - 100px)",
    width: "calc(100% - 100px)",
    autoFocus: false
  }).afterClosed().subscribe((t: any) => {
    // Handle dialog close if needed
  });
}

  addMessage() {

    if (this.inputMessageValue && this.inputMessageValue.length > 0) {
      let message = { User: this.restProviderService.currentUser, DocId: this.model.Id, Date: new Date(), MessageText: this.inputMessageValue, FileName: null };

      if (this.file && this.fileUploadEnabled) {
        if (this.bindingProperty && this.bindingProperty.length > 0 && this.bindingProperty != "Title") {
          let bp = this.bindingProperty.substring(0, this.bindingProperty.lastIndexOf(".")) + ".Id";
          this.file.DocId = this.dfms.getValue(this.model, bp);
        }

        this.fileUploadService.filesInfo.push(this.file);
        this.fileUploadService.files.push(this.file);
        this.fileUploadService.filesNumber = this.fileUploadService.filesInfo.length;
        message.FileName = this.file.Name;
      }

      if (this.bindingProperty && this.bindingProperty.length > 0 && this.bindingProperty != "Title") {
        var res = this.dfms.getValue(this.model, this.bindingProperty);

        if (!res) {
          res = [];
        }

        let bp = this.bindingProperty.substring(0, this.bindingProperty.lastIndexOf(".")) + ".Id";
        message.DocId = this.dfms.getValue(this.model, bp);
        res.push(message);
        this.dfms.assign(this.model, this.bindingProperty + ".Messages", res, true);
      } else {
        this.model.Messages.push(message);
        this.inputMessageValue = "";
      }

      // Set the post-save API call info before emitting save request
      this.utility.afterSaveApiUrl = this.afterSaveApiEndpoint;
      this.utility.afterSaveApiData = { Envelope: { "Id": this.model.Id } };

      this.saveFormReq.emit("");
    } else {
      this.message = this.translationsService.translate("PleaseEnterMessage");

      setTimeout(() => {
        this.message = "";
      }, 3500);
    }
  }

  removeMessage(item) {
    this.model.Messages = this.model.Messages.filter(i => i.MessageText != item.MessageText);
  }

  onFileChange(event) {
    if (this.fileUploadEnabled) {
      this.event = event;

      for (var i = 0; i < this.fileUpload.nativeElement.files.length; i++) {
        if (this.checkFile(this.fileUpload.nativeElement.files[i])) {
          this.file = this.mapItem(this.fileUpload.nativeElement.files[i], ClientAction.New);
        }
      }

      this.fileUpload.nativeElement.value = "";

      // use this property "filesInfo" if you want to access info about images in preSubmitJS event
      if (this.file) {
        if (!this.fileSectionType || this.fileSectionType == 0 || this.fileSectionType == "0" || this.fileSectionType.length == 0) {
          this.fileSectionType = 17;
        }

        this.file.FileSectionType = this.fileSectionType;
      } else {

        //Removed this line, because it hides messages in the checkFile method
        //this.showErrorMessage("Datoteke ni mogoče priložiti.");

      }
    }
  }

  checkFile(file: File): boolean {

    var mbs = file.size / (1024 ** 2);
    if (mbs > environment.maxFileSizeInMbInMessenger) {
      this.showErrorMessage("Največja dovoljena velikost datoteke je presežena. Dovoljena velikost: " + environment.maxFileSizeInMbInMessenger + " mb");
      return false;
    }

    // check if already exists
    if (this.fileUploadService.filesInfo != null && typeof this.fileUploadService.filesInfo != "undefined" && this.fileUploadService.filesInfo.length > 0) {
      let indx = this.fileUploadService.filesInfo.findIndex(x => x.Name == file.name);
      if (indx >= 0) {
        this.alreadyExists = true;
        this.showErrorMessage(this.translationsService.translate('FileAlreadyExists'));
        return false;
      }
    }

    if (this.availableExtensions.length > 0) {
      var fileExtentionSplit = file.name.split(".");
      for (var i = 0; i < this.availableExtensions.length; i++) {
        if (fileExtentionSplit[fileExtentionSplit.length - 1].toLowerCase() == this.availableExtensions[i].toLowerCase()) {
          this.resetResponseStatus();
          return true;
        }
      }

      this.showErrorMessage(this.translationsService.translate("SupportedFileFormats") + " " + this.availableExtensions.toString());

      return false;
    }

    this.resetResponseStatus();
    return true;
  }

  getMessages() {
    if ((!this.bindingProperty || this.bindingProperty.length == 0 || this.bindingProperty == "Title") && this.model) {
      var arr = this.model.Messages;

      if (arr && arr.length > 0) {
        arr.sort((a, b) => a.Id - b.Id);
      }

      return arr;
    } else if (this.model) {
      var res = this.dfms.getValue(this.model, this.bindingProperty);

      if (res) {
        if (res.length > 0) {
          res = res.sort((a, b) => a.Id - b.Id);
        }

        return res;
      }

      return [];
    }

    return [];
  }

  showErrorMessage(message: string) {

    this.utility.reqStatus = ResponseStatus.Error;
    this.utility.reqMessage = message;
    this.utility.reqResponse = true;

    /*setTimeout(() => {
      this.resetResponseStatus();
    }, 5000);*/
  }

  resetResponseStatus() {
    this.utility.reqResponse = false;
  }
}
